document.addEventListener("DOMContentLoaded", function() {
    waitForElm(".js-recommendation-container").then((elem) => {
        new Swiper('.js-recommendation-container', {
            pagination: {
                el: swiperSlider.pagination,
                type: "bullets",
                clickable: true
            },
            navigation: {
                nextEl: '.js-slider-arrow-next',
                prevEl: '.js-slider-arrow-prev'
            },
            breakpoints: {
                320: {
                    initialSlide: 1,
                    slidesPerView: 2,
                    spaceBetween: 12,
                },
                750: {
                    initialSlide: 1,
                    slidesPerView: 4,
                    spaceBetween: 12,
                }
            }
        });
    });
});

function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}